module.exports = __webpack_public_path__ + "img/AdobeStock_248470038.f5759b97.jpeg";